<template>
	<div class="row">

    <div class="eight wide column">
      <div class="ui info icon message" v-if="errorMessage" style="margin-bottom:2em;">
        <i class="warning circle icon"></i>
        {{ errorMessage }}
      </div>
      <form @submit.prevent @keydown.enter.prevent id="action-plan-form" class="ui form">
        <h3 class="ui header" style="margin-bottom:0;"><i class="mobile alternate icon"></i>Content Creation</h3>
        <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">This is what the patient will see</span></h3>

        <div class="required field">
          <label>Action Title</label>
          <input v-model="currentAction.data.title"
                 name="title" type="text" placeholder="e.g. Article Title">
        </div>

        <div class="field">
          <label>Action Description</label>
          <quill-editor v-model="currentAction.data.body"
                        :options="editorOption">
          </quill-editor>
        </div>

        <div class="inline field">
          <div class="ui toggle checkbox">
            <input v-model="currentAction.data.options.userTracking.status"
                   name="require-patient-tracking" type="checkbox" tabindex="0" class="">
            <label>Require patients to track action?</label>
          </div>
        </div>

        <div class="inline field" v-if="currentAction.data.options.userTracking.status === true">
          <div class="ui toggle checkbox" >
            <input v-model="currentAction.data.options.userTracking.isDaily"
                   name="track-daily" type="checkbox" tabindex="0" class="">
            <label>Track daily?</label>
          </div>
        </div>

        <br>
        <h3 class="ui header" style="margin-bottom:0;"><i class="bell
 icon"></i>Reminder Notification Settings</h3>
        <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">Set up what patients see if they choose to enable reminders.</span></h3>

        <div class="ui message">
          <b>For preview of the push notification</b>, use this site: <u><a href="http://pushnotificationpreview.com/">http://pushnotificationpreview.com/</a></u>
        </div>

        <div class="required eleven wide field">
          <label>Reminder Title</label>
          <input  v-model="currentAction.data.options.reminder.title"
                  name="reminder-title" type="text" placeholder="Recommended: less than 30 characters">
        </div>

        <div class="required field">
          <label>Reminder Description</label>
          <textarea v-model="currentAction.data.options.reminder.body"
                    name="reminder-body" type="text" rows="2"  placeholder="Recommended: less than 105 characters">
          </textarea>
        </div>

        <br>

        <h3 class="ui dividing header">
          <i class="settings icon"></i>Admin Settings
        </h3>


        <div class="required field">
          <label style="margin-bottom:0;">
            <i class="blue question large circle icon backoffice-glossary"
               data-content="Internal name of this action for backoffice view only."></i>
            Short Name</label>
          <input v-model="currentAction.data.shortName"
                 name="short-name" type="text" placeholder="Use a short name for internal reference">
        </div>

        <div class="two fields">
          <div class="required field">
            <label>
              <i class="blue question large circle icon backoffice-glossary"
                 data-content="Coaching Program Day when the patient starts seeing this action"></i>
              Start Day
            </label>
          <input v-model="currentAction.data.options.startDay"
                 name="start-day" type="number" style="display:inline-block; width:100px !important" maxlength="3">
          </div>

          <div class="required field">
            <label>
              <i class="blue question large circle icon backoffice-glossary"
                 data-content="Coaching Program Day when the patient will stop seeing this action"></i>
              End Day
            </label>
            <input v-model="currentAction.data.options.endDay"
                   name="end-day" type="number" style="display:inline-block; width:100px !important" maxlength="3">
          </div>
        </div>

        <div class="field">
          <label>Assign to Action Plan(s)
            <br><i style="font-weight: normal;">Leave blank if you don't want to assign it to any action plans.</i>
          </label>

          <select v-model="currentAction.data.options.belongsToTemplate"
                  name="belongs-to-template" multiple class="ui fluid search dropdown">
            <option disabled value="">Not assigned</option>
            <option v-for="template in coachingActionPlansAll"
                    v-if="template.data.deletedStatus === false"
                    :value="template.id">{{ template.data.title }}</option>
          </select>
        </div>

        <plan-template-create
          :isRightFloated="true"
          :type="'action'">
        </plan-template-create>

        <br>
        <br>
        <br>
        <button style=""
                @click.prevent="updateProgramItems('post')"
                v-if="$route.name === 'PageActionPlanCreate'"
                type="submit" class="ui primary submit big button">
          Create New
        </button>
        <button @click.prevent="updateProgramItems('post', false)"
                style="margin-left: 1em; "
                v-if="$route.name === 'PageActionPlanCreate'"
                type="submit" class="ui primary submit big basic button">
          Create and Add Another
        </button>
        <button @click.prevent="updateProgramItems('put')"
                v-if="$route.name === 'EditActionPlan'"
                type="submit" class="ui primary submit big button">
          Save Action
        </button>
        <div class="ui error message"></div>
      </form>
    </div>

    <div class="five wide column">
      <div class="ui sub header">Mobile Preview</div>
      <preview-action-plan :currentAction="currentAction">
      </preview-action-plan>
    </div>

	</div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import PlanTemplateCreate from './PlanTemplateCreate'
  import PreviewActionPlan from './PreviewActionPlan.vue'
  import VueQuillEditor from 'vue-quill-editor'
  import dataStructure from '../../validation/dataStructure'

	export default {
    props: {
      actionid: {
        default: function(){
          return this.$route.params.actionid
        }
      },
      errorMessage: {
        type: String,
        required: false,
        default: function(){
          return this.$route.params.errorMessage
        }
      }
    },
    components: {
      PlanTemplateCreate,
      PreviewActionPlan
    },
		data() {
			return {
			  previousTemplateArray: [],
			  currentAction: JSON.parse(JSON.stringify(dataStructure.actionStructure)),
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic'],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              ['link']
            ]
          },
          placeholder: 'Write the action plan here…'
        }
      }
		},
		computed: {
      ...mapState(['coachingActionPlansAll', 'userEmail', 'userAuthToken']),
    },
		methods: {
      ...mapMutations(['addNewAction', 'removeSelectedAction']),
      getCurrentAction(id){
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlans/' + id;

        this.$http.get(requestUrl).then( (response) => {
          //checks if planType is correct else redirect to correct followup page
          if (response.body.result.planType === 'action') {
            this.currentAction = Object.assign({}, response.body.result);
            this.currentAction.data = Object.assign({}, dataStructure.actionStructure.data, response.body.result.data);
            this.previousTemplateArray = this.currentAction.data.options.belongsToTemplate;

            window.requestAnimationFrame(()=>{
              $('.ui.dropdown').dropdown();
              $('.ui.checkbox').checkbox();
            });
          }

          else if (response.body.result.planType === 'lesson'){
            this.$router.push({ name: 'EditLessonPlan', params: { lessonid: id }});
          }
        }, (error) => {

          if (error.status !== 404) {
            Rollbar.error("failed to fetch planID as action: " + id, error);
          }

          this.$router.push({ name: 'PageActionPlanCreate', params: { errorMessage:  "The requested action id: " + id + " does not exist. Create a new action instead?" }  });

        });
      },
      constructActionObject(){
        this.currentAction.data.lastModifiedTime = new Date().getTime();
        this.currentAction.data.lastModifiedByUser = this.userEmail;
        return this.currentAction;
      },
      initFormValidation(){

        // custom form validation rule
        $.fn.form.settings.rules.endDayAfterStartDay = () => {
          return (parseInt(this.currentAction.data.options.endDay) >= parseInt(this.currentAction.data.options.startDay));
        };

        $('#action-plan-form').form({
          fields: {
            'title': {
              // Cannot be empty
              identifier: 'title',
              rules: [
                {type: 'empty', prompt: 'Action Plan Title cannot be empty'}
              ]
            },
            'reminder-title': {
              // Cannot be empty
              identifier: 'reminder-title',
              rules: [
                {type: 'empty', prompt: 'Reminder Title cannot be empty'},
                {type: 'maxLength[255]', prompt : 'Please enter at most 255 characters'}
              ]
            },
            'reminder-body': {
              // Cannot be empty
              identifier: 'reminder-body',
              rules: [
                {type: 'empty', prompt: 'Reminder Description cannot be empty'},
                {type: 'maxLength[255]', prompt : 'Please enter at most 255 characters'}
              ]
            },
            'short-name': {
              // Cannot be empty
              identifier: 'short-name',
              rules: [
                {type: 'empty', prompt: 'Short Name cannot be empty'}
              ]
            },
            'start-day': {
              // Must not be negative and less than `end-day`
              identifier: 'start-day',
              rules: [
                // For the relevant rule to show, do not change the order of the `rules` array
                {type: 'not[-0]', prompt: 'Enter a valid, positive whole number'},
                {type: 'doesntContain[-]', prompt: 'Start Day cannot be negative'},
                {type: 'not[0]', prompt: 'Start Day cannot be 0'},
                {type: 'integer', prompt: 'Start Day must be whole number'},
                {type: 'integer[1..300]', prompt: 'Start Day must be a whole number between 1 to 300'}
              ]
            },
            'end-day': {
              // FIXME: Must be greater than `start-day`
              identifier: 'end-day',
              rules: [
                // For the relevant rule to show, do not change the order of the `rules` array
                {type: 'not[-0]', prompt: 'Enter a valid, positive whole number'},
                {type: 'doesntContain[-]', prompt: 'End Day cannot be negative'},
                {type: 'not[0]', prompt: 'End Day cannot be 0'},
                {type: 'integer', prompt: 'End Day must be a positive whole number'},
                {type: 'integer[1..300]', prompt: 'End Day must be a whole number between 1 to 300'},
                {type: 'endDayAfterStartDay', prompt: 'End Day must be after Start Day'},
              ]
            }
          },
          inline: true
        });

      },
      updateProgramItems(apiCallMethod, redirect = true) {
        //TODO: When posting, the buttons needs loadingState for validation!!
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlan';
        let validationStatus = $('#action-plan-form').form('is valid');

        if (validationStatus === true){
          if (apiCallMethod === 'post') {
            this.$http.post(requestUrl, this.constructActionObject()).then( (response) => {
              this.currentAction.id = response.body.result.id;
              this.updateProgramPlans(this.previousTemplateArray, this.currentAction, this.coachingActionPlansAll);
              if (redirect === true) {
                this.getProgramItems().then(()=> {
                  this.$router.push({name: 'ActionPlan'});
                })
              }
              else {
                this.currentAction = JSON.parse(JSON.stringify(dataStructure.actionStructure));
                window.scrollTo(0,0);
              }
            });
          }
          else {
            this.$http.put(requestUrl, this.constructActionObject()).then( (response) => {
              this.updateProgramPlans(this.previousTemplateArray, this.currentAction, this.coachingActionPlansAll);
              this.getProgramItems().then(()=> {
                this.$router.push({name: 'ActionPlan'});
              })
            });
          }
        }
        else {
          $('#action-plan-form').form('validate form');
          $('#action-plan-form').form('add errors', ['One or more required fields are empty or contain errors.'])
        }
      },
    },
    watch: {
      '$route' (to, from) {
        if (this.$route.params.actionid !== 'undefined' && isNaN(this.$route.params.actionid ) === false) {
          this.$router.go({ name: 'EditActionPlan', params: { actionid: this.$route.params.actionid }});
        }
      },

      'currentAction.data.options.userTracking.status': function(newValue) {
        if (newValue === false) {
          this.currentAction.data.options.userTracking.isDaily = false;
        }
      },
      'currentAction.data.options.userTracking.isDaily': function(newValue) {
        this.currentAction.data.options.reminder.isDaily = newValue;
      }
    },
		mounted() {
      $('.ui.dropdown').dropdown();
      $('.backoffice-glossary').popup();

      //This part fetches and gets the action plans if it's not 'action/new'
      if (typeof(this.actionid) !== 'undefined' && this.actionid !== 'new') {
        this.getCurrentAction(this.actionid);
      }

      //initializes the rules for form validation
      this.initFormValidation();

    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/content/ActionPlanCreateEdit.vue